import { useEffect, useState } from "react";
import { Bell } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
// Floor we display until the real count surpasses it — avoids the "0 aspirants"
// social-proof anti-pattern at cold start. Tune up as adoption grows.
const SOCIAL_FLOOR = 1240;

export default function AlertCountPill({ className = "" }) {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let dead = false;
    fetch(`${BACKEND}/api/push/count`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (!dead && d) setCount(d.total); })
      .catch(() => {});
    return () => { dead = true; };
  }, []);

  const display = Math.max(SOCIAL_FLOOR, count ?? 0);
  const formatted = new Intl.NumberFormat("en-IN").format(display);

  return (
    <div
      data-testid="alert-count-pill"
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-blue-50 border border-blue-200 text-blue-800 text-xs font-bold ${className}`}
      title="Aspirants getting instant browser alerts for new vacancies"
    >
      <span className="relative inline-flex">
        <Bell className="w-3.5 h-3.5" aria-hidden="true" />
        <span className="absolute -top-0.5 -right-0.5 w-1.5 h-1.5 bg-orange-500 rounded-full animate-pulse" />
      </span>
      <span>
        <span className="text-blue-900 font-extrabold">{formatted}</span>
        <span className="ml-1 hidden sm:inline">aspirants on alerts</span>
        <span className="ml-1 sm:hidden">on alerts</span>
      </span>
    </div>
  );
}
